module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAHlBMVEUAkkbR7N3////sqa3OKzcAkkbb8OX////qpKnOKzcWhat4AAAACXRSTlPUrNSs1P/G/8YgTiD5AAAAMUlEQVR4AWJkQAOMimgCQgLoKkIB7csxDQAAAAIg+6c2g6+DH0VRFEVRlN+iKIqSuRS1jSelBbrG1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/it.png
// module id = yQFQ
// module chunks = 0